import { app } from '../../../../../bootstrap/core';
import { ibanValidationComponent } from './ibanValidation.component';

app.component('ibanValidation', ibanValidationComponent);
